<template>
	<NuxtLayout>
		<NuxtPage />

		<AfxConsentBanner v-if="showConsentBanner" />
	</NuxtLayout>
</template>

<script setup lang="ts">
import AfxConsentBanner from '@/components/afx-consent/AfxConsentBanner.vue'
import { useAfxStore } from '@/stores/afx'

const afxStore = useAfxStore()
const route = useRoute()

const showConsentBanner = computed(() => {
	return Boolean(route.meta.showConsentBanner)
})

onMounted(() => afxStore.syncBannerFromCookie())
</script>
